module.exports = __webpack_public_path__ + "img/hyperx-fury-ultra-preview.500df7b0.png";